import React from "react";

type MonotoneGuideListThumbnailProps = {
  trackNumber: number;
  className?: string;
};

export const MonotoneGuideListThumbnail = ({
  trackNumber,
  className,
}: MonotoneGuideListThumbnailProps) => {
  return (
    <svg
      className={className}
      id="_レイヤー_2"
      data-name="レイヤー_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119.86 119.86"
    >
      <defs>
        <style>
          {`
            .list-cls-1 {
              stroke-width: 3.1px;
            }

            .list-cls-1, .list-cls-2 {
              fill: none;
              stroke: #333;
              stroke-miterlimit: 10;
            }

            .list-cls-3 {
              font-family: 'Noto Sans CJK JP', 'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
              font-size: 42px;
              font-weight: 600;
              text-anchor: middle;
              dominant-baseline: middle;
            }

            .list-cls-2 {
              stroke-width: .71px;
            }

            .list-cls-4 {
              fill: #f2f2f2;
            }
          `}
        </style>
      </defs>
      <g id="_レイヤー_1-2" data-name="レイヤー_1">
        <g>
          <g>
            <rect
              className="list-cls-4"
              x=".35"
              y=".35"
              width="119.15"
              height="119.15"
              rx="34.5"
              ry="34.5"
            />
            <rect
              className="list-cls-2"
              x=".35"
              y=".35"
              width="119.15"
              height="119.15"
              rx="34.5"
              ry="34.5"
            />
          </g>
          <g transform={"translate(0, -12)"}>
            <line
              className="list-cls-1"
              x1="96.89"
              y1="84.4"
              x2="96.89"
              y2="59.1"
            />
            <line
              className="list-cls-1"
              x1="22.97"
              y1="59.1"
              x2="22.97"
              y2="84.4"
            />
            <path
              className="list-cls-1"
              d="M88.05,84.4v-25.3c0-15.65-12.69-28.33-28.33-28.33s-28.33,12.69-28.33,28.33v25.3"
            />
          </g>
          <text className="list-cls-3" x="59.93" y="90.3">
            {trackNumber}
          </text>
        </g>
      </g>
    </svg>
  );
};
